export const testfetchFunction = (user, filedata, pname, restcode) => {
  return new Promise((resolve, reject) => {
    var data = JSON.stringify({
      "path": `projects/${user}/${pname === undefined ? "untitled" : pname}.csv`
    });
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      try {
        if (this.readyState === 4) {
          let resp = JSON.parse(this.responseText);
          testInnerFetching(resp, filedata, restcode)
          resolve(resp)
        } else {
          reject('Error fetching data');
         // console.log(this.responseText)
        }
      } catch (error) {

      }
    });
    xhr.onload = () => {
      if (xhr.status === 200) {
        // Resolve the promise with the response data
        resolve(xhr.response);
      } else {
        // Reject the promise with an error message
        reject('Error fetching data');
      }
    };
    xhr.open("POST", "https://pt5zm6ctoqnyplfogkf4fho55i0uujro.lambda-url.ap-south-1.on.aws/");
    //  xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(data);
  })
}


const testInnerFetching = (jsondata, filedata, restcode) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    Object.keys(jsondata.fields).forEach(key => {
      formData.append(key, jsondata.fields[key]);
    });
    // Actual file has to be appended last.
    formData.append("file", filedata);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", jsondata.url, true);
    xhr.send(formData);
    xhr.onload = function () {
      //console.log("GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG",this.responseText);
      restcode();
      //this.status === 204 ? resolve() : reject(this.responseText);
    };

    xhr.onerror = (e) => {
    }
  })

}